// extracted by mini-css-extract-plugin
export var button = "button-module--button--27646";
export var buttonDarkmode = "button-module--button--darkmode--ba598";
export var buttonDisabled = "button-module--button--disabled--72b0d";
export var buttonFullWidth = "button-module--button--full-width--1d464";
export var buttonLoading = "button-module--button--loading--5fe6b";
export var buttonPrimary = "button-module--button--primary--a1e2f";
export var buttonPrimarySmall = "button-module--button--primary-small--68c2f";
export var buttonSecondary = "button-module--button--secondary--ba9fc";
export var buttonSmall = "button-module--button--small--3bb52";
export var buttonTertiary = "button-module--button--tertiary--930a1";
export var button__child = "button-module--button__child--f3bd7";
export var button__loadingIcon = "button-module--button__loading-icon--d93d3";
export var grid = "button-module--grid--27ad7";
export var gridWithRowGap = "button-module--grid--with-row-gap--70c5d";
export var maxWidthContainer = "button-module--max-width-container--fd9a6";
export var mt0 = "button-module--mt-0--c088f";
export var mt1 = "button-module--mt-1--13cd8";
export var mt2 = "button-module--mt-2--a0c43";
export var mt3 = "button-module--mt-3--90ed0";
export var mt4 = "button-module--mt-4--5ca78";
export var mt5 = "button-module--mt-5--cab8b";
export var mt6 = "button-module--mt-6--b8eed";
export var removeVisuallyHidden = "button-module--remove-visually-hidden--a903f";
export var visuallyHidden = "button-module--visually-hidden--35b20";
export var widgetBase = "button-module--widget-base--d6580";